export default __webpack_public_path__ + "static/media/daemmkeil-next-036.53962876.jpg";